import Axios from "axios";
import { BaseService } from "./BaseService";
import { Postit, PostitFiltro, PostitResponsable, PostitResponsableFiltro } from "@/model/Postit";
BaseService.loadAxios();

const RESOURCE_NAME = "/postit";

export class PostitService {
    public static async getPostits(filtro: PostitFiltro) {
        return Axios.post("postits", filtro);
    }

    public static async grabarPostit(postit: Postit) {
        return Axios.post(RESOURCE_NAME, postit);
    }

    public static async postitResponsables(filtro: PostitResponsableFiltro) {
        return Axios.post(`${RESOURCE_NAME}/responsable`, filtro);
    }

    public static async asignarPostit(filtro: PostitResponsable) {
        return Axios.post(`${RESOURCE_NAME}/asignar`, filtro);
    }

    public static async postitLeido(id: string) {
        return Axios.get(`${RESOURCE_NAME}/leido/${id}`);
    }
}